"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linearGradientRe = void 0;
// this regex will return an array of linear gradient color values when doing $var.match(linearGradientRe)
var linearGradientRe = /#[0-9a-fA-F]{3,6}|rgb ?\([ 0-9.%,]+?\)/g;
exports.linearGradientRe = linearGradientRe;